import React, { useEffect, useState } from 'react'

import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

export const DialogMessage = ({ title, message }) => {
  const [open, setOpen] = useState(true)
  const [top, setTop] = useState((  ( parseInt(window.embedHeight) / 2 )  - 100) + "px")

  useEffect(() => {
    if (open) {
      let halfwayDownIshPixels = ( parseInt( window.embedHeight || 800 ) / 2 )  - 100;
      // console.log(`halfwayDownIshPixels`, halfwayDownIshPixels)
      // console.log(`window.embedPerceivedTop`, window.embedPerceivedTop)
      let top = parseInt(window.embedPerceivedTop || 0)
      setTop( (top + halfwayDownIshPixels) + "px")
    }
  }, [open])

  const handleClose = () => {
    setOpen(false)
  }

  const backdropStyle = {
    backdropFilter: 'blur(2px)',
    overflow: "scroll"
  }

  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    // minHeight: 'var(--content-min-height)',
    position: 'fixed',
    top: top,
  }
  // Centered on the screen, like the No Graphic modal it can follow (BR-5696). Inside an
  // iframe the screen is the parent page's, so it keeps the perceived-top offset there.
  if (window.self === window.top) {
    style.top = '50%'
    style.transform = 'translateY(-50%)'
  }

 
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      style={backdropStyle}
    >
      <DialogContent style={style}>
        <div className="instant-win-modal">
          <div className="instant-win-modal-content">
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            {/* BR-5696: authored copy is plain text; keep its line breaks and wrap long words */}
            <div style={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{message}</div>
            <DialogActions>
              <Button onClick={handleClose} autoFocus>
                Close
              </Button>
            </DialogActions>
          </div>
        </div>
      </DialogContent>
    </Modal>
  )
}

export default DialogMessage
